// @ts-nocheck: converted from JS

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { web as webRoute } from '@/support/route';

const useSelectStudyCreationFormModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return {
    openSelectStudyCreationFormModal: () =>
      dispatch({
        type: 'OPEN_MODAL',
        modal: 'SELECT_STUDY_CREATION_FORM',
        props: {
          onSubmit: (formId) => {
            navigate(
              webRoute('studies.new', {
                formId,
              })
            );
          },
        },
      }),
  };
};

export default useSelectStudyCreationFormModal;
